module.exports = __webpack_public_path__ + "img/tl8.014f839c.webp";